export default "__VITE_ASSET__McL340xx__"